// extracted by mini-css-extract-plugin
var _1 = "Button_button__zEOqE";
var _2 = "Button_cancel__nuQYO";
var _3 = "768px";
var _4 = "Button_primary__wRpZz";
var _5 = "Button_primaryInverse__s1bQU";
var _6 = "\"../../shared.module.css\"";
var _7 = "Button_tertiary__yDO8H";
var _8 = "Button_tertiaryInverse__quHID";
export { _1 as "button", _2 as "cancel", _3 as "md", _4 as "primary", _5 as "primaryInverse", _6 as "shared", _7 as "tertiary", _8 as "tertiaryInverse" }
